<div class="container-small" *ngIf="projects && projects.length > 0">
  <h1>Onze andere projecten</h1>
  <div class="flex nav-proj-bottom-vert wrap">
    <a class="c-button" [routerLink]="['/project', project.id]" *ngFor="let project of projects">
      {{ project.reference }} | {{ project.city }}
    </a>
  </div>
</div>